module.exports = __webpack_public_path__ + "img/instagram-icon.0e84d592.png";